import React, { FC } from 'react'
import NewClientContainer from 'containers/NewClient/ClientInfo'

const NewClientPage: FC = () => <NewClientContainer />

export default NewClientPage
